import { Action, createReducer, on } from '@ngrx/store';
import { IXpacProxyState } from '../../utils/interfaces/store.interfaces';
import { clearPermissionDataAction } from '../actions/app.actions';
import { getAuthInfoXpacProxyFailedAction, getAuthInfoXpacProxySuccessAction } from '../actions/xpacProxy.action';

const initialState: IXpacProxyState = {
  permission: null
};

export const xpacProxyReducerImplicit = createReducer(
  initialState, 
  on(getAuthInfoXpacProxySuccessAction, (state, {data: permission}) => ({
    ...state,
    permission,
  })),
  on(getAuthInfoXpacProxyFailedAction, (state,) => ({
    ...state,
    permission: null,
  })),
  on(clearPermissionDataAction, (state) => ({
    ...state,
    permission: null,
  })),
);

export function xpacProxyReducer(state: any, action: Action): IXpacProxyState {
  return xpacProxyReducerImplicit(state, action);
}
